module.exports = __webpack_public_path__ + "img/16ad7e3.jpg";